import { Navigate } from 'react-router-dom';

// Everything onboarding-related now lives on /app/home (it switches state internally),
// so /app just redirects there.
export function AppGate() {
  return <Navigate to="/app/home" replace />;
}
